module.exports = __webpack_public_path__ + "static/img/security03.67fb2bea.png";